import { spacing } from '@naf/theme';
import styled from '@emotion/styled';

export const CampaignDiscountWrapper = styled.div`
  display: flex;
  gap: ${spacing.space16};
`;

export const DiscountStateWrapper = styled.div``;
